import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    usePage,
} from "@/comn/hooks";
import {
    COMN_BASE,
    COMN_URLS,
    COMN_APIS,
    SF_APP_DTL_TRPT,
    SG_APP_DTL_CNTR_LIST,
} from "@/tz/go/egaz/osci/lpco/comn/services/OsciLpcoComnAppService";
import { SF_APP_DTL_ADD_ITM, SF_APP_RGST_OFCR_ADD_ITM } from "@/tz/go/egaz/osci/lpco/comn/services/OsciLpcoComnAppAddItmService";
import { APP_DTL_ADD_ITM } from "./APP_DTL_ADD_ITM";
import { APP_RGST_OFCR_ADD_ITM } from "./APP_RGST_OFCR_ADD_ITM";

export const APP_DTL_TRPT = (props: any) => {
    const { pgeUid, menuId } = usePage();
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    const [trptCntrList, setTrptCntrList] = useState(comnUtils.getGridData([]));
    const [cntr, setCntr] = useState(false);
    const [edit, setEdit] = useState(false);

    const form = {
        appDtlTrpt: useForm({
            defaultSchema: SF_APP_DTL_TRPT,
        }),

        appDtlAddItm: useForm({
            defaultSchema: SF_APP_DTL_ADD_ITM,
        }),

        appDtlOfcrAddItm: useForm({
            defaultSchema: SF_APP_RGST_OFCR_ADD_ITM,
        }),
    };

    const grid = {
        appDtlCntrList: useGrid({
            defaultSchema: SG_APP_DTL_CNTR_LIST,
        }),
    };

    useEffect(() => {
        handler.setInit();
    }, []);

    /*
     * Register Application Transport Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        setInit: async () => {
            setEdit(props?.param?.edit);
            fetch.getAppTrptInfo.fetch();
        },
    };

    const fetch = {
        // Get Application Transport Information !== 신청서 운송 정보 조회 ==!.
        getAppTrptInfo: useFetch({
            api: () => COMN_APIS.getAppTrptInfo({ ...props.state }),
            enabled: !!props.appId,
            onSuccess: (data) => {
                form.appDtlTrpt.setValues(data.appTrptInfo?.content.osceAppTrptDDto || []);
                if (data.appTrptInfo.content.osceAppCntrDDtoList!) {
                    setCntr(true);
                    setTrptCntrList(comnUtils.getGridData(data.appTrptInfo.content.osceAppCntrDDtoList || []));
                }
            },
            onError: (error) => {},
            showToast: false,
        }),
    };

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Layout direction="col">
                        <Layout>
                            <Layout.Left>
                                <Group.Title title={"T_TRPT"} titleSize={1}></Group.Title>
                            </Layout.Left>
                        </Layout>

                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.appDtlTrpt.schema.trptMode} controlSize={10} />
                            </Group.Row>

                            <Group.Row>
                                <Group.Control {...form.appDtlTrpt.schema.trptMeanNm} />
                                <Group.Control {...form.appDtlTrpt.schema.trptMeanNo} />
                            </Group.Row>

                            <Group.Row>
                                <Group.Control {...form.appDtlTrpt.schema.trptCoNm} controlSize={10} />
                            </Group.Row>

                            <Group.Row>
                                <Group.Control {...form.appDtlTrpt.schema.arvlPort} />
                                <Group.Control {...form.appDtlTrpt.schema.arvlXptdDt} />
                            </Group.Row>

                            <Group.Row>
                                <Group.Control {...form.appDtlTrpt.schema.dptrPort} />
                                <Group.Control {...form.appDtlTrpt.schema.dptrXptdDt} />
                            </Group.Row>

                            <Group.Row>
                                <Group.Control {...form.appDtlTrpt.schema.cstmOfce} />
                                <Group.Control {...form.appDtlTrpt.schema.blNo} />
                            </Group.Row>
                        </Group.Section>
                    </Layout>

                    {cntr && (
                        <Layout direction="col">
                            <Layout>
                                <Layout.Left>
                                    <Group.Title title={"Container"} titleSize={1}></Group.Title>
                                </Layout.Left>
                            </Layout>

                            <Group>
                                <Group.Body>
                                    <Grid {...grid.appDtlCntrList.grid} data={trptCntrList} />
                                </Group.Body>
                            </Group>
                        </Layout>
                    )}
                        {/* ADD ITEM DETAIL */}
                        <APP_DTL_ADD_ITM param={props.state} form={form} area={"TRN"} />

                        {/* Officer ADD ITEM DETAIL */}
                        <APP_RGST_OFCR_ADD_ITM param={props.state} form={form} area={"TRN"} onOfcrAddItmChange={props.onOfcrAddItmChange} onRegisterTabSave={props.onRegisterTabSave} onRegisterTabValid={props.onRegisterTabValid} />
                </Group.Body>
            </Group>
        </Page>
    );
};
